import React, { Component } from 'react';
// import './corporatePartners.scss';
import getConfig from 'next/config';

const config = getConfig().publicRuntimeConfig;

export default class CorporatePartners extends Component {
	render() {
		const { img } = this.props;
		return (
			<div className="partners-container">
				<div className="partners-wrapper container">
					<div className="partners-out">
						<div className="partners-content">
							<h2>Partners</h2>
							<div className="partners-hr"></div>
							<p>
								Trusted by the largest brands and corporations, and the most
								impactful foundations around the world
							</p>
						</div>
					</div>
					<div className="partners-logos">
						<div className="partners-list-wrapper">
							<img
								src={`${config.cdnUrl}${img}`}
								alt="nonprofit"
								loading="lazy"
							/>
						</div>
					</div>
				</div>
			</div>
		);
	}
}
